export default {
  submit: {
    en: "Submit test",
    de: "Test einreichen",
    ru: "Отправить тест",
    tr: "Testi gönder",
    el: "Υποβολή δοκιμής",
    bg: "Изпратете теста",
    ro: "Trimiteți testul",
    cs: "Odeslat test",
    sh: "Pošalji test",
    hu: "Teszt beküldése"
  },
  repeat: {
    en: "Repeat",
    de: "Wiederholen",
    ru: "Повторите",
    tr: "Tekrar et",
    el: "Επανάληψη",
    bg: "Повторете",
    ro: "Repetați",
    cs: "Opakovat",
    sh: "Ponovi",
    hu: "Ismétel"
  },
  button_next: {
    en: "Next step",
    de: "Zum nächsten Schritt",
    ru: "К следующему шагу",
    tr: "Sonraki adım",
    el: "Επόμενο βήμα",
    bg: "Следваща стъпка",
    ro: "Pasul următor",
    cs: "Další krok",
    sh: "Sledeći korak",
    hu: "Következő lépés"
  },
  result_text: {
    de: "Sie können jetzt Ihre Fehler einsehen. Da es mehrere Fehler gibt,sollte der Test ggf. die Schulung wiederholt werden",
    en: "You can now review your mistakes. Since there are several mistakes, the test should be repeated if necessary.",
    ru: "Теперь вы можете просмотреть свои ошибки. Поскольку ошибок несколько, при необходимости тест следует повторить.",
    tr: "Şimdi hatalarınızı gözden geçirebilirsiniz. Birden fazla hata olduğundan, gerekirse test tekrar edilmelidir.",
    el: "Μπορείτε τώρα να ελέγξετε τα λάθη σας. Δεδομένου ότι υπάρχουν πολλά λάθη, θα πρέπει να επαναληφθεί η δοκιμή, αν χρειαστεί.",
    bg: "Вече можете да прегледате грешките си. Тъй като има няколко грешки, ако е необходимо, тестът трябва да бъде повторен.",
    ro: "Acum puteți să vă examinați greșelile. Deoarece sunt mai multe greșeli, testul trebuie repetat dacă este necesar.",
    cs: "Nyní si můžete prohlédnout své chyby. Vzhledem k tomu, že je několik chyb, měl by být test v případě potřeby zopakován.",
    sh: "Sada možete pregledati svoje greške. Pošto ima nekoliko grešaka, test bi trebalo ponoviti ako je potrebno.",
    hu: "Most megtekintheti a hibáit. Mivel több hiba van, a tesztet szükség esetén meg kell ismételni."
  },
  answer_all_questions: {
    en: "Please attempt all questions",
    de: "Bitte beantworten Sie alle Fragen",
    ru: "Пожалуйста, попробуйте ответить на все вопросы",
    tr: "Lütfen tüm soruları cevaplayın",
    el: "Παρακαλώ απαντήστε σε όλες τις ερωτήσεις",
    bg: "Моля, отговорете на всички въпроси",
    ro: "Vă rugăm să răspundeți la toate întrebările",
    cs: "Prosím, odpovězte na všechny otázky",
    sh: "Molimo vas da odgovorite na sva pitanja",
    hu: "Kérjük, válaszoljon az összes kérdésre"
  },

  repeat_course: {
    en: "Please repeat the course",
    de: "Wiederholen Sie bitte den Kurs",
    ru: "Пожалуйста, повторите курс",
    tr: "Lütfen kursu tekrar edin",
    el: "Παρακαλώ επαναλάβετε το μάθημα",
    bg: "Моля, повторете курса",
    ro: "Vă rugăm să repetați cursul",
    cs: "Prosím, zopakujte kurz",
    sh: "Molimo vas da ponovite kurs",
    hu: "Kérjük, ismételje meg a kurzust"
  },
  repeat_action: {
    en: "Repeat",
    de: "Wiederholen",
    ru: "Повторить",
    tr: "Tekrar et",
    el: "Επανάληψη",
    bg: "Повторете",
    ro: "Repetați",
    cs: "Opakovat",
    sh: "Ponovi",
    hu: "Ismétel"
  },
  cancel: {
    en: "Cancel",
    de: "Abbrechen",
    ru: "Отмена",
    tr: "İptal et",
    el: "Ακύρωση",
    bg: "Отказ",
    ro: "Anulați",
    cs: "Zrušit",
    sh: "Otkaži",
    hu: "Mégse"
  }
};
